Pixlee.module('WidgetsApp.Horizontal', function(Horizontal, App, Backbone, Marionette, $) {
    var _this = this,
        API;
    Horizontal.Controller = App.Controllers.Application.extend({
        initialize: function() {

        },
        getPhotoCollectionView: function() {

        }
    });

});